var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 63.1111H62.2222C62.6937 63.1111 63.1459 62.9238 63.4793 62.5904C63.8127 62.257 64 61.8049 64 61.3334C64 60.8619 63.8127 60.4097 63.4793 60.0763C63.1459 59.7429 62.6937 59.5556 62.2222 59.5556H53.3333V15.1111C53.3333 14.6396 53.146 14.1875 52.8126 13.8541C52.4792 13.5207 52.0271 13.3334 51.5556 13.3334H44.4444C43.9729 13.3334 43.5208 13.5207 43.1874 13.8541C42.854 14.1875 42.6667 14.6396 42.6667 15.1111V59.5556H37.3333V36.4445C37.3333 35.973 37.146 35.5208 36.8126 35.1874C36.4792 34.854 36.0271 34.6667 35.5556 34.6667H28.4444C27.9729 34.6667 27.5208 34.854 27.1874 35.1874C26.854 35.5208 26.6667 35.973 26.6667 36.4445V59.5556H21.3333V25.7778C21.3333 25.3063 21.146 24.8541 20.8126 24.5207C20.4792 24.1873 20.0271 24 19.5556 24H12.4444C11.9729 24 11.5208 24.1873 11.1874 24.5207C10.854 24.8541 10.6667 25.3063 10.6667 25.7778V59.5556H3.55556V2.66669C3.55556 2.1952 3.36825 1.74301 3.03486 1.40962C2.70146 1.07622 2.24927 0.888916 1.77778 0.888916C1.30628 0.888916 0.854097 1.07622 0.520699 1.40962C0.187301 1.74301 0 2.1952 0 2.66669V61.3334C0 61.8049 0.187301 62.257 0.520699 62.5904C0.854097 62.9238 1.30628 63.1111 1.77778 63.1111ZM46.2222 16.8889H49.7778V59.5556H46.2222V16.8889ZM30.2222 38.2222H33.7778V59.5556H30.2222V38.2222ZM14.2222 27.5556H17.7778V59.5556H14.2222V27.5556Z",
    fill: "url(#paint0_linear_4576_677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4576_677",
    x1: -37.7931,
    y1: 6.63365,
    x2: 287.419,
    y2: 243.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.0eb848005e0696bc6ad605630fe09670.svg";
export { ForwardRef as ReactComponent };